import React from 'react';
import PropTypes from 'prop-types';
import { DisplayControl } from './controls';

const SectionHeader = ({ section, updateSettings, getOptionValue, solutionTypes }) => (
  <div className="section-container">
    <h3 className="section-heading">{section.title}</h3>
    <div className="section-wrapper">
      {solutionTypes.map((type) => (
        <div className="section-item-wrapper" key={type.id}>
          <p>{type.name}</p>
          <DisplayControl
            value={getOptionValue('unit', section.title, type.id)}
            onChange={(value) => updateSettings('unit', section.title, type.id, value)}
          />
        </div>
      ))}
    </div>
  </div>
);

SectionHeader.propTypes = {
  section: PropTypes.object.isRequired,
  updateSettings: PropTypes.func.isRequired,
  getOptionValue: PropTypes.func.isRequired,
  solutionTypes: PropTypes.array.isRequired,
};

export default SectionHeader;
